import React, { Component } from 'react'
import {connect} from 'react-redux';
import  { Button, Label, Icon, Segment, Divider, Dropdown, Table, Placeholder, Popup} from 'semantic-ui-react';
import { HashRouter as Router, Link} from 'react-router-dom'
import {bindActionCreators} from 'redux';
import * as tokenActions from '../actions/actions';
import '../App.css'
import firebase from '../firebase';
import 'semantic-ui-css/semantic.min.css';
import '../App.css';
import Nodes from './nodes';
import '../index.css';
import { toast } from 'react-toastify';
var moment = require('moment');
require('moment-timezone');


/*
    This is the netowrk management page/portal. It is used the manage some aspoects of the the sensor networks remotely.
    This page allows authorised users to:
        * View current duty cycle of the nwtwork.
        * Override current duty cycle of the network with a new duty cycle. 
        * View the nwtwork's dutcy cycle change logs.
        * Manually add a new node.
        * Edit node which had been automatically added after successfull node deployment. 
*/

class NetworkSettings extends Component {
    constructor(props){
        super(props);
        this.state = {
            userName:props.userName,
            email:props.userEmail,
            sleepOptions : null,
            newSleepTime:10,
            initCalled:false,
            sleepLogsVisible:false,
            logState:'View Logs',
            requiredRoles:["Client", "Admin", "Superadmin"],
            isLoading:true
        }

        this.renderCurrentSleep = this.renderCurrentSleep.bind(this);
        this.handleChangeSleepTime = this.handleChangeSleepTime.bind(this);
        this.handleChange = this.handleChange.bind(this);
        

    }

componentWillReceiveProps(props){
    // if(props.userId){
    //     this.setS
    // }
   if(props.nodeInfoData){
       this.setState({nodeInfo: props.nodeInfoData}, () =>{
       })
   }
   if(props.userInfoData){
        this.setState({userId:props.userId, organisation:props.userInfoData.organisation, userRole:props.userInfoData.accessLevel, isLoading:false}, () =>{
        })
   }
   if(props.userInfoSuccess === false){
    this.setState({isLoading:false})
   }
    if(props.userId && this.state.initCalled === false){
        this.setState({initCalled:true}, () =>{
            this.props && 
            this.props.tokenActions.getSleepLogs(this.props.userId);
            this.props.tokenActions.getNodeInfo();
            this.props.tokenActions.getUserInfo(props.userId);
        })
   
    }
    this.setState({userName:props.userName, email:props.userEmail})

    if(props.sleepInfoSuccess === true && props.sleepInfoData){
        this.setState({sleepLogs:props.sleepInfoData}, ()=>{
        })
    }

    if(props.changeSleepSuccess && props.changeSleepSuccess === true ){
        toast("Sleep time changed Successfully!")
    } 

    if(props.changeSleepSuccess === false ){
        toast.error("Error changing sleep time!")
    }

    if(props.addNodeSuccess === true){
        toast.success("Device Added Successully")
    }
    if(props.addNodeSuccess === false){
        toast.error("Error. Could not add Node!")
    }
    if(props.editNodeSuccess === true){
        toast.success("Changes applied successully!")
    } 
    if(props.editNodeSuccess === false){
        toast.error("Error. Could not apply new changes")
    }


    this.props.tokenActions.hideAlerts();


}
componentDidMount(){
    this.setState({
        orgs:[ { key: 'arb', value: 'arb',text: 'National Arboretum Canberra' }, { key: 'uc', value: 'uc',text: 'University of Canberra'} ]
    })


    var sleepRef = firebase.db.ref('sleep_controls/sleep_time');
    sleepRef.on('value', (snapshot) => {
                let value = null;
                if(snapshot.val() < 61){
                    value = snapshot.val() + " minute(s)"
                } else{
                    value = parseFloat(snapshot.val()/60, 10).toFixed(2) + " hours"
                }
                if(value!==null){
                    this.setState({currentSleepTime:value})
                }

    });

    let sleepOptions = [
        {key:'1min', value:1, text:"1 minute"},
        {key:'2min', value:2, text:"2 minutes"},
        {key:'5min', value:5, text:"5 minutes"},
        {key:'10min', value:10, text:"10 minutes"},
        {key:'30 min', value:30, text:"30 minutes"},
        {key:'60min', value:60, text:"1 hour"},
        {key:'3hours', value:180, text:"3 hours"}
    ]

    this.setState({sleepOptions:sleepOptions})
    this.props && 
    this.props.tokenActions.getSleepLogs(this.props.userId);
    this.props.tokenActions.getNodeInfo();
    this.props.tokenActions.getUserInfo(this.props.userId);


}
renderCurrentSleep(val){
    let content =[];
    if(val){
        content.push(
            <div>
                <Popup style = {{minWidth:"300px"}} trigger = {
                    <div>
                        <h5>Current Duty Cycle <Icon name = 'question'></Icon> </h5>
                        <Label>
                            Duty Cycle
                            <Label.Detail>{val}</Label.Detail>
                        </Label>
                    </div>
                }
                header='Duty Cycle (Sampling Frequency)'
                position='right center'
                content = 'Network Sleep Time + Wake Time (10s)'
                />
                
                
                <Divider/>
            </div>
        )
        return content;
    } else{
        return content;
    }

}

renderSleepLogs(data){
    let content = [];
    let logs = data.sleepLog
    if(logs){
        Object.keys(logs).forEach(key =>{
            // let conversions = 
            let value;
            if(logs[key].sleep_time < 61){
                value = logs[key].sleep_time + " minutes"
            } else{
                value = parseFloat(logs[key].sleep_time /60, 10).toFixed(2) + " hours"
            }
            content.push(
                <Table.Row>
                <Table.Cell collapsing >
                    {moment(logs[key].timestamp * 1000).format('DD/MM/YY HH:mm')}
                </Table.Cell>

                <Table.Cell collapsing>
                    {value}
                </Table.Cell>

                <Table.Cell collapsing>
                    {logs[key].source}
                    {logs[key].updated_by  &&
                        <Label style={{float:"right"}} color='orange' horizontal size={'tiny'} >Updated by: {logs[key].updated_by}</Label>
                    
                    }
                    {logs[key].full_node_id  && logs[key].node_info &&
                        <Label style={{float:"right"}} color='green' horizontal size={'tiny'} > F{logs[key].node_info.forest_num} N{logs[key].node_info.node_num}</Label>                
                    }

                    
                </Table.Cell>
            </Table.Row>
            )
        })
        return content;

    } else{
        return content;
    }
}

handleChangeSleepTime(e){
    e.preventDefault();
    let value = this.state.newSleepTime;
    let user = this.props.userId
    this.props.tokenActions.changeSleepTime(value, user);

}

handleChange(e, data){
    if(data.id === "sleepDropdown"){
        this.setState({newSleepTime:data.value})
    }
    if(data.id === "toggleLogs"){
        this.setState({sleepLogsVisible:!this.state.sleepLogsVisible, 
            logState:(this.state.logState === "Hide Logs") ? "View Logs" : "Hide Logs"}
            )
    }
}





    render() {
        // const {userName} = this.state;
    

      return (
        <div id ="" className = 'normal-left'>
         
            <h3>Sensor Network Settings</h3>
           
            {
                
                (this.props.authenticated) ? 
                    (this.state.userRole && this.state.requiredRoles.includes(this.state.userRole)) ? 
                        (<Segment raised >
                            <h3>Duty Cycle Configurations</h3>
                                <Divider/>
                        {this.state.currentSleepTime && this.renderCurrentSleep(this.state.currentSleepTime)}
                    
                            <div className = 'column'>
                                <h5 style={{marginLeft:''}} >Change Duty Cycle</h5>
                                <Dropdown  label ={<h4>Change Duty Cycle</h4>} placeholder = {this.state.currentSleepTime || '10 minutes'} id="sleepDropdown" disabled = {false} style={{marginLeft:'', width :'20%'}} onChange={this.handleChange}  selection options={this.state && this.state.sleepOptions}/>
                                <p>
                                    <Button  style={{marginTop:'3px'}} secondary size ={'tiny'} onClick={this.handleChangeSleepTime}>Apply</Button>
                                    <Button  style={{marginTop:'3px', float:''}} primary size ={'tiny'} id ='toggleLogs' onClick={this.handleChange} content = {this.state.logState}/>
                                </p>
                            </div>
                            {this.state.sleepLogs && this.state.sleepLogsVisible && 
                                <div>
                                    <Divider/>
                                    <h3>Duty Cycle Logs</h3>
                                    <div style={{maxHeight:'500px', overflow:'scroll', marginTop:"10px"}}>
                                        <Divider/>
                                        <Table id = 'sleepTable' inverted celled striped selectable>                   
                                            <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell rowSpan='2'>Change Date</Table.HeaderCell>
                                                <Table.HeaderCell rowSpan='2'>Value</Table.HeaderCell>
                                                <Table.HeaderCell rowSpan='2'>Reason</Table.HeaderCell>
                                            </Table.Row>
                                            </Table.Header>
                                            <Table.Body>

                                                { this.renderSleepLogs(this.state.sleepLogs)}
                                                
                                            </Table.Body>
                                        </Table>
                                    </div>
                                </div>


                            }
                                {this.state.nodeInfo && this.state.organisation && this.state.userId &&
                                    <Nodes nodeList={this.state.nodeInfo} userOrg = {this.state.organisation} userId ={this.state.userId}/>
                                }

                            </Segment>)
                        :
                        
                        (
                        this.state.isLoading === false ?
                            <Router>
                                <Segment raised>
                                
                                    <Label color='red' as={Link} to ={'/no way jose'} ribbon>
                                        Unauthorised
                                    </Label>
                                    Access to Network Settings require Client Level privileges. If you require access, you can submit a request for an elevated role <Label color='red' as={Link} to={'/account'}>here</Label> If you've recently created this account, please wait for an approval email. 
                                </Segment>
                            </Router>
                        :
                            <Segment raised style ={{textAligh:'center'}}>
                                <h4>Loading...</h4>
                                <Placeholder fluid>
                                    <Placeholder.Header>
                                        <Placeholder.Line />
                                        <Placeholder.Line />
                                    </Placeholder.Header>
                                    <Placeholder.Paragraph>
                                        <Placeholder.Line />
                                        <Placeholder.Line />
                                        <Placeholder.Line />
                                    </Placeholder.Paragraph>
                                </Placeholder>
                                
                                 
                            </Segment>
                            
                        )
                        
                    :
                (
                <Router>
                    <Segment raised>
                    
                        <Label color='orange' as={Link} to ={'/login'} ribbon>
                            Log In
                        </Label>
                        Please Log In to Access Network Settings.
                    </Segment>
                </Router>)
            
            }   
        </div>
        
      )
    }
}

function mapStateToProps(state) {
    return {
        ...state.initState
    };
}
function mapDispatchToProps(dispatch) {
    return {
        tokenActions: bindActionCreators(tokenActions, dispatch)
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    
)(NetworkSettings);



// WEBPACK FOOTER //
// ./src/components/networksettings.js